import { makeStyles } from '@material-ui/core'
import Grid from '@mui/material/Grid'
import {
  FormControl,
  FormHelperText,
  MenuItem,
  Select,
  TextField,
} from '@mui/material'
import {
  getFormControlErrorText,
  isFormControlError,
} from 'src/services/formHelperService'
import CustomDatePicker from 'src/components/BuyPolicy/common/CustomDatePicker'
import { GENDER_LIST } from 'src/utils/constants/BuyPolicy'
import React from 'react'
import IconButton from '@mui/material/IconButton'
import { Clear } from '@mui/icons-material'
import { addScroll, removeScroll } from 'src/utils/commonMethods'

const LifeNomineeDetailsForm = ({ lifeMemberDetailsForm, providerDetails }) => {
  const classes = useStyles()

  const { values } = lifeMemberDetailsForm

  return (
    <div className={classes.root}>
      <div className={classes.nomineeDetailsForm}>
        <Grid container spacing={2}>
          <Grid item xs={12} md={6} lg={4}>
            <FormControl fullWidth>
              <TextField
                id='firstName'
                name='nomineeDetails.firstName'
                type='text'
                placeholder='First Name *'
                required
                value={values?.nomineeDetails?.firstName}
                onChange={lifeMemberDetailsForm.handleChange}
                onBlur={lifeMemberDetailsForm.handleBlur}
                error={isFormControlError(
                  lifeMemberDetailsForm,
                  'nomineeDetails.firstName'
                )}
                helperText={getFormControlErrorText(
                  lifeMemberDetailsForm,
                  'nomineeDetails.firstName'
                )}
                className={`${classes.inputTextField} ${classes.firstNameField}`}
              />
            </FormControl>
          </Grid>

          <Grid item xs={12} md={6} lg={4}>
            <FormControl fullWidth>
              <TextField
                id='lastName'
                name='nomineeDetails.lastName'
                type='text'
                placeholder='Last Name *'
                required
                value={values?.nomineeDetails?.lastName}
                onChange={lifeMemberDetailsForm.handleChange}
                onBlur={lifeMemberDetailsForm.handleBlur}
                error={isFormControlError(
                  lifeMemberDetailsForm,
                  'nomineeDetails.lastName'
                )}
                helperText={getFormControlErrorText(
                  lifeMemberDetailsForm,
                  'nomineeDetails.lastName'
                )}
                className={`${classes.inputTextField} ${classes.firstNameField}`}
              ></TextField>
            </FormControl>
          </Grid>

          <Grid item xs={12} md={6} lg={4}>
            <FormControl fullWidth>
              <CustomDatePicker
                id='dateOfBirth'
                name='nomineeDetails.dateOfBirth'
                type='date'
                placeholder='Date of birth *'
                value={values?.nomineeDetails?.dateOfBirth}
                onChange={lifeMemberDetailsForm.handleChange}
                onBlur={lifeMemberDetailsForm.handleBlur}
                error={isFormControlError(
                  lifeMemberDetailsForm,
                  'nomineeDetails.dateOfBirth'
                )}
                helperText={getFormControlErrorText(
                  lifeMemberDetailsForm,
                  'nomineeDetails.dateOfBirth'
                )}
                className={`${classes.inputTextField} ${classes.firstNameField}`}
              ></CustomDatePicker>
            </FormControl>
          </Grid>

          <Grid item xs={12} md={6} lg={4}>
            <FormControl
              fullWidth
              className={classes.formContainerStyles}
              error={isFormControlError(
                lifeMemberDetailsForm,
                'nomineeDetails.profession'
              )}
            >
              <Select
                id='relation'
                name='nomineeDetails.relation'
                placeholder={'Relation'}
                displayEmpty
                defaultValue=''
                className={`${classes.inputTextField} ${classes.nomineeDetailsField}`}
                value={values?.nomineeDetails?.relation}
                sx={{
                  '& .MuiSelect-iconOutlined': {
                    display: values?.nomineeDetails?.relation ? 'none' : '',
                  },
                }}
                onChange={lifeMemberDetailsForm.handleChange}
                endAdornment={
                  <IconButton
                    id='nomineeRelationClear'
                    sx={{
                      display: values?.nomineeDetails?.relation ? '' : 'none',
                    }}
                    className={'clear-button'}
                    // onClick={() => handleInputClearForPointOfContact('relation')}
                  >
                    <Clear />
                  </IconButton>
                }
                onOpen={() => {
                  removeScroll()
                }}
                onClose={() => {
                  addScroll()
                }}
              >
                <MenuItem value={''} className={'default-menu-item'}>
                  Relation
                </MenuItem>
                {providerDetails?.nomineeRelationType?.map(
                  (relationListItem) => (
                    <MenuItem
                      key={relationListItem?.value}
                      value={relationListItem?.value}
                    >
                      {relationListItem?.label}
                    </MenuItem>
                  )
                )}
              </Select>
              {isFormControlError(
                lifeMemberDetailsForm,
                'nomineeDetails.profession'
              ) && (
                <FormHelperText>
                  {getFormControlErrorText(
                    lifeMemberDetailsForm,
                    'nomineeDetails.profession'
                  )}
                </FormHelperText>
              )}
            </FormControl>
          </Grid>

          <Grid item xs={12} md={6} lg={4}>
            <FormControl
              fullWidth
              className={classes.formContainerStyles}
              error={isFormControlError(
                lifeMemberDetailsForm,
                'nomineeDetails.profession'
              )}
            >
              <Select
                id='gender'
                name='nomineeDetails.gender'
                placeholder={'Gender'}
                displayEmpty
                className={classes.inputTextField}
                value={values?.nomineeDetails?.gender ?? ''}
                onChange={lifeMemberDetailsForm.handleChange}
                onBlur={lifeMemberDetailsForm.handleBlur}
                error={isFormControlError(
                  lifeMemberDetailsForm,
                  'nomineeDetails.firstName'
                )}
                helperText={getFormControlErrorText(
                  lifeMemberDetailsForm,
                  'nomineeDetails.firstName'
                )}
                sx={{
                  '&  .MuiSelect-select': {
                    height: '0.7rem !important',
                    minHeight: 'unset',
                  },
                  '& .MuiSelect-iconOutlined': {
                    display: values?.nomineeDetails?.gender ? 'none' : '',
                  },
                }}
                endAdornment={
                  <IconButton
                    id='nomineeGenderClear'
                    sx={{
                      display: values?.nomineeDetails?.gender ? '' : 'none',
                    }}
                    className={'clear-button'}
                    // onClick={() => handleInputClearForPointOfContact('gender')}
                  >
                    <Clear />
                  </IconButton>
                }
                onOpen={() => {
                  removeScroll()
                }}
                onClose={() => {
                  addScroll()
                }}
              >
                <MenuItem value={''} className={'default-menu-item'}>
                  Gender
                </MenuItem>
                {GENDER_LIST?.map((option) => (
                  <MenuItem key={option?.enum} value={option?.enum}>
                    {option?.label}
                  </MenuItem>
                ))}
              </Select>
              {isFormControlError(
                lifeMemberDetailsForm,
                'nomineeDetails.profession'
              ) && (
                <FormHelperText>
                  {getFormControlErrorText(
                    lifeMemberDetailsForm,
                    'nomineeDetails.profession'
                  )}
                </FormHelperText>
              )}
            </FormControl>
          </Grid>
        </Grid>
      </div>
    </div>
  )
}

export default LifeNomineeDetailsForm

const useStyles = makeStyles({
  root: {
    display: 'flex',
    flexDirection: 'column',
    gap: '10px',
  },
  inputTextField: {
    borderRadius: '5px !important',
    backgroundColor: 'white !important',
    fontSize: '12px !important',
    fontFamily: 'Roboto !important',
    width: '100%',
  },
  firstNameField: {
    '&  .MuiOutlinedInput-input': {
      height: '0.7rem',
    },
  },
  nomineeDetailsField: {
    '&  .MuiSelect-select': {
      height: '0.7rem !important',
      minHeight: 'unset',
    },
  },
  formContainerStyles: {
    margin: 0,
  },
})
